import * as moment from 'moment'

export const getTimeNow = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss")
}

export const formatTime = (time, str) => {
    if (str)
        return moment(time).format(str);

    return moment(time).format('YYYY/MM/DD HH:mm:ss')
}

export const getDiffMinutesFromNow = (time, isDuration = false) => {
    var now = moment(new Date());
    var duration = moment.duration(now.diff(time));
    var minutes = Math.floor(duration.asMinutes());

    var days = Math.floor(minutes / (24 * 60));
    minutes = minutes % (24 * 60);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    var str = '';

    if (days == 1)
        str = `${days} day `;
    else if (days > 1)
        str = `${days} days `;

    if (hours == 1)
        str += `${hours} hour `;
    else if (hours > 1)
        str += `${hours} hours `;

    if (minutes > 0)
        str += `${minutes} ${minutes < 2? 'minute': 'minutes'}`;

    str += isDuration ? '': ' ago';

    return str;
}

export const getDiffSecondsFromNow = (time, isDuration) => {
    var now = moment(new Date());
    var duration = moment.duration(now.diff(time));
    var seconds = Math.floor(duration.asSeconds());

    var days = Math.floor(seconds / (24 * 60 * 60));
    seconds = seconds % (24 * 60 * 60);
    var hours = Math.floor(seconds / (60 * 60));
    seconds = seconds % (60 * 60);
    var minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;

    var str = '';

    if (days == 1)
        str = `${days} day `;
    else if (days > 1)
        str = `${days} days `;

    if (hours == 1)
        str += `${hours} hour `;
    else if (hours > 1)
        str += `${hours} hours `;

    if (minutes == 1)
        str += `${minutes} minute `;
    else if (minutes > 1)
        str += `${minutes} minutes `;

    if (seconds > 0)
        str += `${seconds} ${seconds < 2? 'second': 'seconds'}`;

    str += isDuration ? '': ' ago';

    return str;
}

export const getDiffMinutes = (fromTime, finishTime, isDuration = false) => {
    var now = moment(finishTime);
    var duration = moment.duration(now.diff(fromTime));
    var minutes = Math.floor(duration.asMinutes());

    var days = Math.floor(minutes / (24 * 60));
    minutes = minutes % (24 * 60);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    var str = '';

    if (days == 1)
        str = `${days} day `;
    else if (days > 1)
        str = `${days} days `;

    if (hours == 1)
        str += `${hours} hour `;
    else if (hours > 1)
        str += `${hours} hours `;

    if (minutes > 0)
        str += `${minutes} ${minutes < 2? 'minute': 'minutes'}`;

    str += isDuration ? '': ' ago';

    return str;
}

export const shortenText = (str, n) => {
    if (str) {
      if (str.length > n)
        return str.slice(0, n) + "...";
      
      return str;
    }

    return '';
}

export const getDiffMinutesFromNowVN = (time, isDuration = false) => {
    var now = moment(new Date());
    var duration = moment.duration(now.diff(time));
    var minutes = Math.floor(duration.asMinutes());

    var days = Math.floor(minutes / (24 * 60));
    minutes = minutes % (24 * 60);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    var str = '';

    if (days == 1)
        str = `${days} ngày `;
    else if (days > 1)
        str = `${days} ngày `;

    if (hours == 1)
        str += `${hours} giờ `;
    else if (hours > 1)
        str += `${hours} giờ `;

    if (minutes > 0)
        str += `${minutes} ${minutes < 2? 'phút': 'phút'}`;

    if (days == 0 && hours == 0 && minutes == 0)
        return 'vài giây trước';

    str += isDuration ? '': ' trước';

    return str;
}

export const getDiffSecondsFromNowVN = (time, isDuration) => {
    var now = moment(new Date());
    var duration = moment.duration(now.diff(time));
    var seconds = Math.floor(duration.asSeconds());

    var days = Math.floor(seconds / (24 * 60 * 60));
    seconds = seconds % (24 * 60 * 60);
    var hours = Math.floor(seconds / (60 * 60));
    seconds = seconds % (60 * 60);
    var minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;

    var str = '';

    if (days == 1)
        str = `${days} ngày `;
    else if (days > 1)
        str = `${days} ngày `;

    if (hours == 1)
        str += `${hours} giờ `;
    else if (hours > 1)
        str += `${hours} giờ `;

    if (hours == 0) {
        if (minutes == 1)
            str += `${minutes} phút `;
        else if (minutes > 1)
            str += `${minutes} phút `;

        if (seconds > 0)
            str += `${seconds} ${seconds < 2? 'giây': 'giây'}`;
    } else {
        if (minutes > 0)
            str += `${minutes} ${minutes < 2? 'phút': 'phút'}`;
    }

    if (hours == 0 && minutes == 0)
        return 'vài giây trước';
    str += isDuration ? '': ' trước';

    return str;
}

export const getDiffMinutesVN = (fromTime, finishTime, isDuration = false) => {
    var now = moment(finishTime);
    var duration = moment.duration(now.diff(fromTime));
    var minutes = Math.floor(duration.asMinutes());

    var days = Math.floor(minutes / (24 * 60));
    minutes = minutes % (24 * 60);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    var str = '';

    if (days == 1)
        str = `${days} ngày `;
    else if (days > 1)
        str = `${days} ngày `;

    if (hours == 1)
        str += `${hours} giờ `;
    else if (hours > 1)
        str += `${hours} giờ `;

    if (minutes > 0)
        str += `${minutes} ${minutes < 2? 'phút': 'phút'}`;

    str += isDuration ? '': ' trước';

    return str;
}